import './carousel.scss';

import React, { useEffect, useRef } from 'react';
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
  Dot,
  CarouselContext,
} from 'pure-react-carousel';

const Carousel = ({ onChange, ...props }) => {
  const ref = useRef();

  useEffect(() => {
    const { carouselStore } = ref.current;

    const handleOnChange = () => {
      if (onChange) {
        onChange(carouselStore.state.currentSlide);
      }
    };

    carouselStore.subscribe(handleOnChange);
    return () => carouselStore.unsubscribe(handleOnChange);
  }, [onChange]);

  return <CarouselProvider ref={ref} {...props} />;
};

Carousel.Slider = Slider;
Carousel.Slide = Slide;
Carousel.ButtonBack = ButtonBack;
Carousel.ButtonNext = ButtonNext;
Carousel.DotGroup = DotGroup;
Carousel.Dot = Dot;
Carousel.Context = CarouselContext;

export default Carousel;
